<template>
  <div
    id="no-scroll-lock"
    class="fixed inset-0 pt-6 pb-16 lg:px-10vw bg-center bg-cover overflow-auto z-10"
    :class="[ post.type ? 'lg:flex-c lg:flex-col lg:pb-0 lg:pt-3vw' : '']"
    :style="!mobile ? `background-image: url(${content.backgroundImage})` : ''"
  >
    <!-- Background color overlay -->
    <div
      class="fixed inset-0 bg-secondary"
      :class="{ 'opacity-90': !mobile }"
    />

    <!-- Titles and type etc -->
    <div
      class="relative lg:flex w-full"
      :class="{ 'lg:h-36vw': component !== 'post' }"
    >
      <div class="lg:w-1/4 px-5vw lg:pr-2vw lg:pl-0">
        <span
          class="inline-flex items-center p-2 bg-white font-medium text-primary leading-none text-sm"
        >
          {{ content.postTypeHeading }}
          <IconBase
            :icon="`icon${post.type}`"
            :size="'18px'"
            class="ml-2"
          />
        </span>

        <br>

        <span
          class="inline-block p-2 bg-white"
        >
          <h1
            class="font-medium leading-none"
            v-html="post.title"
          />
        </span>

        <br>
        <!-- Additional duration for video posts -->
        <span
          v-if="post.type === 'video' && post.duration"
          class="bg-white p-2 font-medium text-primary inline-block leading-none text-sm"
          v-html="post.duration"
        />
        <!-- Additional length for gallery posts -->
        <span
          v-if="post.type === 'gallery'"
          class="bg-white p-2 font-medium text-primary inline-block leading-none text-sm"
        >
          {{ post.gallery.length }} Images
        </span>
        <!-- The post description on desktop -->
        <p
          v-if="!mobile && post.type !== 'post' && content.postDescription"
          class="bg-white p-1vw mt-6 text-sm font-light xxl:text-base"
          v-html="content.postDescription"
        />
        <!-- The additional image for articles -->
        <div
          v-if="post.type === 'post'"
          class="h-45vw md:h-30vw lg:h-15vw mt-6 bg-center bg-cover"
          :style="`background-image: url(${post.image.sizes.thumbnail})`"
        >
          <span
            role="img"
            :aria-label="post.image.alt"
          />
        </div>
      </div>
      <!-- The media content -->
      <Component
        :is="component"
        :post="post"
        class="relative lg:w-3/4"
        :class="[ component !== 'post' ? 'h-70vw md:h-60vw lg:h-36vw my-6 lg:my-0' : ' lg:max-h-38vw lg:overflow-y-auto' ]"
      />
    </div>

    <!-- The post description moved below the media on mobile -->
    <div
      v-if="mobile && post.type !== 'post' && content.postDescription"
      class="relative px-5vw mb-6"
    >
      <p
        class="p-5vw bg-white"
        v-html="content.postDescription"
      />
    </div>
    <!-- Cta button in each post -->
    <div
      v-if="content.ctaPath"
      class="lg:w-full flex justify-center lg:justify-end mt-10"
    >
      <div class="lg:w-3/4 flex-c relative">
        <ButtonMain
          :type="post.type === 'panorama' ? 'internal' : 'external'"
          :cta="content.buttonText"
          :path="content.ctaPath"
          :icon="post.type === 'panorama' ? 'iconpanorama' : 'iconlinkout'"
          class="py-3 px-8"
        />
      </div>
    </div>

    <ButtonClose
      class="absolute top-6 right-6"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ButtonClose from '@/components/buttons/ButtonClose.vue'
import panorama from '@/components/Panorama.vue'
import post from '@/components/Post.vue'
import gallery from '@/components/Gallery.vue'
import vid from '@/components/Video.vue'
import IconBase from '@/components/icons/IconBase'
import ButtonMain from '@/components/buttons/ButtonMain.vue'

export default {
  name: 'Media',

  components: {
    ButtonClose,
    panorama,
    post,
    gallery,
    vid,
    IconBase,
    ButtonMain
  },

  meta() {
    return {
      title: 'Coventry university | Virtual experience'
    }
  },

  computed: {
    ...mapState([ 'mobile', 'slug' ]),
    ...mapGetters([ 'post', 'panorama', 'highlight', 'posts' ]),

    content() {
      const backgroundImage = this.post.image ? this.post.image.sizes.large : this.panorama.panorama.sizes.large
      const postTypeHeading = this.post.type === 'panorama' ? '360' : this.post.typeHeading
      const postDescription = this.post.type === 'panorama' ? this.highlight.panorama[0].description : this.post.description
      const buttonText = this.post.type === 'panorama' ? 'Explore more' : this.post.linkout_cta
      const ctaPath = this.post.type === 'panorama' ? `/explore/${this.highlight.panorama[0].tour.post_name}/${this.highlight.panorama[0].entry.post_name}` : this.utmHref(this.post.linkout, 'tier-2-cta')

      return {
        backgroundImage,
        postTypeHeading,
        postDescription,
        buttonText,
        ctaPath
      }
    },

    component() {
      return this.post.type === 'video' ? vid : this.post.type
    }
  },

  created() {
    this.$store.commit('noScroll', true)
  },

  beforeDestroy() {
    this.$store.commit('noScroll', false)
  }
}
</script>
